var path = window.location.host;
var parts = path.split('.')
var domain = parts[0]

// API URL

// export const URL = "https://flickjobs.in:8443/AD-MARKETPLACE/api/v1/";
export const URL = "https://api.flickjobs.in/api/v1/";
// export const URL = "x`https://uat-api.flickjobs.in:8080/api/v1/";
// export const URL = "http://192.168.30.170:3001/api/v1/";

export const Schema = domain

// APIs for jobs
export const ListJobsUrl = `${URL}viewAllJob`;
export const UploadAttachmentUrl = `${URL}jobDescriptionUpload`;
export const UpdateAttachmentUrl = `${URL}jobDescriptionUpdate`;
export const DownloadAttachmentUrl = `${URL}jobDescriptionDownload`;
export const UploadAttachmentUrlEmail = `${URL}emailReceivedFromClientUpload`;
export const UpdateAttachmentUrlEmail = `${URL}emailReceivedFromClientUpdate`;
export const DownloadAttachmentUrlEmail = `${URL}emailReceivedFromClientDownload`;
export const GetJobByIdUrl = `${URL}getJobByJobId`;
export const DownloadResumeUrl = `${URL}downLoadCV`;
export const ListJobTitlesUrl = `${URL}jobTitles`;
// export const ListCompanyNamesUrl = `${URL}admin/getAllCompanies`;
export const ListCompanyNamesUrl = `${URL}admin/getCompanies`;
export const ListJobCompanyNameUrl = `${URL}listDistinctCompanyName`;
export const ListNewQualificationsurl = `${URL}listDistinctQualification`;
export const ListMinCtc = `${URL}listDistinctMinCTC`;
export const ListMaxCtc = `${URL}listDistinctMaxCTC`;
export const ListMinExperience = `${URL}listDistinctMinExperience`;
export const ListMaxExperience = `${URL}listDistinctMaxExperience`;
export const ListNewKeySkillsurl = `${URL}listDistinctKeySkill`;
export const ListJobTitleUrl = `${URL}listDistinctJobTitle`;
export const ListCitiesUrl = `${URL}getAllCity`;
export const ListStatesUrl = `${URL}getAllStates`;
export const ListDesignationsUrl = `${URL}getAllDesignations`;
export const ListIndustriesUrl = `${URL}getAllIndustries`;
export const ListKeyskillsUrl = `${URL}getAllKeySkills`;
export const ListQualificationsUrl = `${URL}getAllQualifications`;
export const ListCtcsUrl = `${URL}getAllCtc`;
export const ListExperiencesUrl = `${URL}getAllExperience`;
export const ListPreferredCandidateLocationsUrl = `${URL}getAllPCLocation`;
export const GetCityByStateNameUrl = `${URL}getAllCityByStateName`;
export const AddJobUrl = `${URL}postingJob`;
export const SortJobsUrl = `${URL}viewAllJob?sortBy=`;
export const ActiveAndDeActiveJobUrl = `${URL}activeAndDeactive`;
export const SearchJobsUrl = `${URL}viewAllJob?search=`;
export const AddAgentWorkListUrl = `${URL}addToWishlist`;
export const JobReportDownloadUrl = `${URL}JobReportDownload`;
export const AgentWishListUrl = `${URL}listAgentWishList`;
export const JobStatusListUrl = `${URL}getJobStatus`;
export const ChangeJobStatusUrl = `${URL}changeJobStatus`;
export const AgentReleaseJobUrl = `${URL}releaseJob`;
export const RecrutingAgentRequest = `${URL}recruitingAgent/companyDetails`;
export const GetJobbyJobId = `${URL}getJobByJobId`;
// APIs for candidates
export const ListJobIdUrl = `${URL}listDistinctJobId`;
export const ListCandidateQualificationsurl = `${URL}listDistinctCandidateQualification`;
export const ListCandidatesUrl = `${URL}getAllCandidates`;
export const UpdateStatusUrl = `${URL}updateStatus`;
export const ListStatusUrl = `${URL}listStatus`;
export const ListStatusForAccountantUrl = `${URL}listStatusForAccountant`;
export const ListStatusForIRUrl = `${URL}listStatusForIR`;
export const GetStatusHistoryUrl = `${URL}getCandidateStatusByApplyJobId`;
export const ListAppliedCandidatesUrl = `${URL}getAllCandidateAppliedByAgent`;
export const ListAppliedCandidatesByAgentUrl = `${URL}getCandidateByAgentEmailId`;
export const ListAppliedCandidatesByAgentAndIdUrl = `${URL}getAllCandidateByJobIdAndAgentId`;
export const GetCandidateByIdUrl = `${URL}getCandidateById`;
export const SortCandidatesUrl = `${URL}getAllCandidates?sortBy=`;
export const SearchCandidatesUrl = `${URL}getAllCandidates?search=`;
export const AddCandidateUrl = `${URL}applyJob`;
export const EditCandidateUrl = `${URL}updateCandidate`;
export const UploadResumeUrl = `${URL}uploadCv`;
export const UpdateResumeUrl = `${URL}updateCv`;
export const DownloadBulkResumesUrl = `${URL}downloadAllCv`;
export const DownloadBulkResumeForAgentUrl = `${URL}bulkFileDownloadForAgent`;
export const DownloadSelectedCandidatesResumeUrl = `${URL}downloadSelectedCv`;
export const DownloadReportCandidate = `${URL}candidateListByStatusOrJobIdReportDownload`;
export const ListCandidatesForInvoiceUrl = `${URL}getCandidatesForInvoice`;
export const ListAgentCodeUrl = `${URL}listDistinctAgentCode`;
export const DeleteCandidateUrl = `${URL}deleteCandidate`;
export const SendJobApplication = `${URL}send-job-application`;

// APIs for Recruiting Agenst
export const LoginUrl = `${URL}logIn`;
export const OtpVerificationUrl = `${URL}recruitingAgent/OTPVerification`;
export const ChangePasswordUrl = `${URL}recruitingAgent/changePassword`;
export const ForgotPasswordUrl = `${URL}recruitingAgent/forgotPassword`;
export const ListRecruitingAgentsUrl = `${URL}recruitingAgent/getAllRecruitingAgents`;
export const GetAgentsByStatusUrl = `${URL}dashboard/getAllAgentByStatus`;
export const SortRecruitingAgentsUrl = `${URL}recruitingAgent/getAllRecruitingAgents?sortBy=`;
export const SearchRecruitingAgentsUrl = `${URL}recruitingAgent/getAllRecruitingAgents?search=`;
export const RecruitingAgentStatusUrl = `${URL}recruitingAgent/getAllAgentStatus`;
export const AgentViewProfileUrl = `${URL}recruitingAgent/downloadProfileImage`;
export const GetRecruitingAgentByIdUrl = `${URL}recruitingAgent/getAgentByAgentId`;
export const AgentRegistrationUrl = `${URL}recruitingAgent/agentRegistration`;
export const UploadProfImageUrl = `${URL}recruitingAgent/profileImageUpload`;
export const UpdateProfImageUrl = `${URL}recruitingAgent/profileImageUpdate`;
export const UploadChequeImageUrl = `${URL}recruitingAgent/chequeUpload`;
export const UpdateChequeImageUrl = `${URL}recruitingAgent/chequeUpdate`;
export const UploadAadharImageUrl = `${URL}recruitingAgent/aadhaarUpload`;
export const UpdateAadharImageUrl = `${URL}recruitingAgent/updateAadhaar`;
export const UploadPanImageUrl = `${URL}recruitingAgent/panCardUpload`;
export const UpdatePanImageUrl = `${URL}recruitingAgent/panCardUpdate`;
export const DownloadChequeUrl = `${URL}recruitingAgent/downloadCheque`;
export const ApproveOrRejectAgentUrl = `${URL}admin/ApprovedOrRejectedAgent`;
export const DownloadAadharUrl = `${URL}recruitingAgent/downloadAadhaar`;
export const DownloadPanUrl = `${URL}recruitingAgent/downloadPanCard`;
export const GetStateCodeUrl = `${URL}getStateByName`;
export const UpdateAgreementImageUrl = `${URL}recruitingAgent/agreementUpdate`;
export const UploadAgreementImageUrl = `${URL}recruitingAgent/agreementUpload`;
export const DownloadAgreementUrl = `${URL}recruitingAgent/downloadAgreement`;
export const SendWelcomeMailUrl = `${URL}recruitingAgent/welcomeMail`;
export const SendReuploadMailUrl = `${URL}recruitingAgent/agreementCorrectionMail`;
export const AgentDashboardDataUrl = `${URL}dashboard/agentDashboardData`;

// APIs for Key Account Manager
export const KeyAccountManagerGetUrl = `${URL}KeyAccountManager/getAll`;
export const AdminAssignAgentUrl = `${URL}admin/assignAgent`;

// APIs for Users
export const ListAllUsersUrl = `${URL}admin/getAllUsers`;
export const UpdateUserUrl = `${URL}admin/updateUser`;
export const CreateUserUrl = `${URL}admin/addUser`;
export const SortUsersUrl = `${URL}admin/getAllUsers?sortBy=`;
export const SearchUsersUrl = `${URL}admin/getAllUsers?search=`;
export const ActiveOrDeactiveUserUrl = `${URL}admin/activeAndDeactiveUser`;

// APIs for Dashboard
export const GetDashboardDataUrl = `${URL}dashboard/dashboardData`;
export const DownloadAgentReportUrl = `${URL}recruitingAgent/agentListReportDownload`;
export const DownloadInternalTeamReportUrl = `${URL}internalRecruiter/InternalRecruiterReportDownload`;
export const DownloadJobReportUrl = `${URL}JobPostReportDownload`;
export const DownloadCandidateReportUrl = `${URL}candidateListReportDownload`;
export const TopCompanyNamesUrl = `${URL}dashboard/topCompanyName`;
export const TopRecruitersByCandidateUrl = `${URL}dashboard/topRecruitersName`;
export const TopInternalByCandidateUrl = `${URL}dashboard/topInternalRecruiter`;
export const TopIndustriesUrl = `${URL}dashboard/topIndustriesName`;
export const CompaniesWithHigherRevenueUrl = `${URL}dashboard/higherRevenueCompanyName`;
export const RecruitersWithHighBackout = `${URL}dashboard/blackoutRecruiters`;
export const GetJobAnalyticsUrl = `${URL}dashboard/JobData`;
export const GetDailyJobDataUrl = `${URL}dashboard/dailyJobPosted`;
export const GetDailyCvAnalyticsUrl = `${URL}dashboard/dailyCVSubmittedByRecruiter`;
export const GetDailyCvByIRUrl = `${URL}dashboard/dailyCVSubmittedByRecruiter`;
export const GetMonthlyJobAnalyticsUrl = `${URL}dashboard/monthlyJobPosted`;
export const GetMonthlyCandidateAnalyticsUrl = `${URL}dashboard/monthlyCVSubmittedByRecruiter`;
export const GetMonthlyCandidatesJoinedUrl = `${URL}dashboard/monthlyDataOfCandidateByStatus?status=joined`;
export const GetMonthyRevenueGenerateUrl = `${URL}dashboard/monthlyRevenueGenerated`;
export const GenerateInvoiceUrl = `${URL}recruitingAgent/generateInvoice`;
export const GetInvoiceDetailsUrl = `${URL}recruitingAgent/getInvoiceDetails`;
export const DownloadUserLogReportUrl = `${URL}UserLog/userLogReportDownload`;
export const SubmitInvoiceDetailsUrl = `${URL}recruitingAgent/addInvoiceAndAgentDetails`;
export const DownloadOverAllStatusReportUrl = `${URL}dashboard/getOverAllStatusReport`;
export const DownloadRecruiterPerformanceReportUrl = `${URL}dashboard/getDailyRecruiterPerformance`;

// Api's Add purpose for future uses
export const CompanyNameAddUrl = `${URL}admin/addCompany`;
export const IndustriesAddUrl = `${URL}addIndustry`;
export const StatesAddUrl = `${URL}addState`;
export const CityAddUrl = `${URL}addCity`;
export const PreferredLocationAddUrl = `${URL}addPCLocation`;
export const GetCountriesUrl = `${URL}getAllCountry`;
export const GetStatesUrl = `${URL}getStatesByCountryId`;
export const GetCitiesUrl = `${URL}getCities`;

//Api's for resend otp
export const emailResendOtpUrl = `${URL}recruitingAgent/emailResetOTP`;
export const phoneResendOtpUrl = `${URL}recruitingAgent/mobileResetOTP`;


//Api's for Company master
export const ListCompanyMasterUrl = `${URL}company/getAllCompanies`;
export const AssignCompanyURL = `${URL}admin/assignCompany`;
export const AddCompanyUrl = `${URL}company/addCompany`;
export const UpdateCompanyUrl = `${URL}company/updateCompany`;
export const CompanyStatusChangeUrl = `${URL}company/changeStatus`;
export const CompanyDeleteUrl = `${URL}company/delete`;
export const CompanyExportUrl = `${URL}company/listReportDownload`;